import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {NotificationsService} from "../../service/notifications.service";
import {switchMap} from 'rxjs/operators';
import {PasswordMatchValidatorUtils} from "../../utils/password-match-validator-utils";
import {Title} from "@angular/platform-browser";
import {RecoverPasswordService} from "../../service/recover-password.service";

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent {

  loading: boolean = false;
  success = false;
  invalidToken: boolean = false;
  passwordForm: FormGroup;
  tokenString: string;

  constructor(private recoverPasswordService: RecoverPasswordService,
              private notificationService: NotificationsService,
              private router: Router,
              private fb: FormBuilder,
              private route: ActivatedRoute,
              private passwordValidator: PasswordMatchValidatorUtils,
              private titleService: Title) {
    this.passwordForm = this.fb.group({
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, {validators: passwordValidator.passwordMatchValidator});
  }

  ngOnInit(): void {
    this.route.queryParamMap.pipe(
      switchMap((params: ParamMap) => {
        this.tokenString = params.get('tokenString');
        return this.tokenString
      })
    ).subscribe();
    this.titleService.setTitle('Filings Summary - Password Recovery');
  }

  submit() {
    this.recoverPasswordService.newPassword(this.passwordForm.get('newPassword').value, this.passwordForm.get('confirmPassword').value, this.tokenString).subscribe({
      next: resp => {
        this.success = true;
      }, error: error => {
        this.invalidToken = true
      }
    })
  }
}
